import React from 'react';
import AutoCompleteTextInput from '../../../../controls/autoCompleteTextInput.jsx';
import TextAreaInput from '../../../../controls/textAreaInput.jsx';
import TextInput from '../../../../controls/textInput.jsx';
import { apiGet, apiPost } from '../../../../services/apiClient';
import { getRoles } from '../../../../services/userRights';
import { isUndefined } from 'util';
import {findPhoneNumbersInText } from 'libphonenumber-js'

export default class AddressTab extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            busyCount: 0,
            validShipmentCity: true,
            validDeliveryCity: true,
            warehouses: []
        };
    }

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

    initParcelData(parcel) {
        parcel.canEditShipmentAddress = true;
        parcel.canEditDeliveryAddress = true;
        parcel.shipmentWarehouseId = null;
        parcel.shipmentWarehouseName = "";
        parcel.shipmentAddressId = null;
        parcel.shipmentAddressName = "";
        parcel.shipmentAddress = null;
        parcel.shipmentAddressComment = "";
        parcel.shipmentPointContactInfoId = null;
        parcel.deliveryWarehouseId = null;
        parcel.deliveryWarehouseName = "";
        parcel.deliveryAddressId = null;
        parcel.deliveryAddressName = "";
        parcel.deliveryAddress = null;
        parcel.deliveryAddressComment = "";
        parcel.deliveryPointContactInfoId = null;
        parcel.senderUserId = null;
        parcel.senderName = "";
        parcel.senderContactInfo = "";
        parcel.recipientUserId = null;
        parcel.recipientName = "";
        parcel.recipientContactInfo = "";
        parcel.recipientInn = "";
        parcel.recipientCompanyName = "";
        return parcel;
    }

    reloadReferences() {
        this.validateCity(this.props.parcel.shipmentAddress ? this.props.parcel.shipmentAddress.city : "", "shipmentAddressCity");
        this.validateCity(this.props.parcel.deliveryAddress ? this.props.parcel.deliveryAddress.city : "", "deliveryAddressCity");

        this.updateBusyCount(1);
        return apiGet('ref/warehouses/list/' + this.props.parcel.companyId)
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.warehouses = data.entries;
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
    }

    fillModel(parcel) {
        var shipmentWarehouseId = parseInt(this.props.parcel.shipmentWarehouseId);
        parcel.shipmentWarehouseId = isNaN(shipmentWarehouseId) ? null : shipmentWarehouseId;
        parcel.shipmentWarehouseName = this.replaceEmptyString(this.props.parcel.shipmentWarehouseName);
        if (this.props.parcel.shipmentAddress && !isUndefined(this.props.parcel.shipmentAddress.id)) {
            parcel.shipmentAddressId = this.props.parcel.shipmentAddress.id;
        }
        parcel.shipmentAddress = this.props.parcel.shipmentAddress;
        parcel.shipmentAddressComment = this.replaceEmptyString(this.props.parcel.shipmentAddressComment);
        parcel.shipmentPointContactInfoId = this.props.parcel.shipmentPointContactInfoId;
        var deliveryWarehouseId = parseInt(this.props.parcel.deliveryWarehouseId);
        parcel.deliveryWarehouseId = isNaN(deliveryWarehouseId) ? null : deliveryWarehouseId;
        parcel.deliveryWarehouseName = this.replaceEmptyString(this.props.parcel.deliveryWarehouseName);
        if (this.props.parcel.deliveryAddress && !isUndefined(this.props.parcel.deliveryAddress.id)) {
            parcel.deliveryAddressId = this.props.parcel.deliveryAddress.id;
        }
        parcel.deliveryAddress = this.props.parcel.deliveryAddress;
        parcel.deliveryAddressComment = this.replaceEmptyString(this.props.parcel.deliveryAddressComment);
        parcel.deliveryPointContactInfoId = this.props.parcel.deliveryPointContactInfoId;
        parcel.senderUserId = this.props.parcel.senderUserId;
        parcel.senderName = this.replaceEmptyString(this.props.parcel.senderName);
        parcel.senderContactInfo = this.replaceEmptyString(this.props.parcel.senderContactInfo);
        parcel.recipientUserId = this.props.parcel.recipientUserId;
        parcel.recipientName = this.replaceEmptyString(this.props.parcel.recipientName);
        parcel.recipientContactInfo = this.replaceEmptyString(this.props.parcel.recipientContactInfo);
        parcel.recipientInn = this.replaceEmptyString(this.props.parcel.recipientInn);

        let senderCompanyName = this.props.parcel.senderCompanyName ? this.props.parcel.senderCompanyName : this.props.parcel.shipmentWarehouseName;
        parcel.senderCompanyName = this.replaceEmptyString(senderCompanyName);

        let recipientCompanyName = this.props.parcel.recipientCompanyName ? this.props.parcel.recipientCompanyName : this.props.parcel.deliveryWarehouseName;
        parcel.recipientCompanyName = this.replaceEmptyString(recipientCompanyName);

        return parcel;
    }

    hasFormErrors(errors) {
        return !isUndefined(errors)
            && (errors.shipmentWarehouseId
                || errors.shipmentWarehouseName
                || errors.shipmentAddress
                || errors.shipmentAddressCity
                || errors.shipmentAddressComment
                || errors.shipmentAddressPostalCode
                || errors.deliveryWarehouseId
                || errors.deliveryWarehouseName
                || errors.deliveryAddress
                || errors.deliveryAddressCity
                || errors.deliveryAddressComment
                || errors.deliveryAddressPostalCode
                || errors.senderUserId
                || errors.senderName
                || errors.senderContactInfo
                || errors.recipientUserId
                || errors.recipientName
                || errors.recipientContactInfo
                || errors.recipientInn
                || errors.recipientCompanyName);
    }

    validateForm(fieldName) {
        var result = null;

        if (isUndefined(fieldName) || fieldName === "shipmentWarehouseName") {
            if (!this.isEmptyString(this.props.parcel.shipmentWarehouseName) && this.props.parcel.shipmentWarehouseName.length > 200) {
                result = result ? result : {};
                result.shipmentWarehouseName = "Длина поля Точка отправления не должна превышать 200 символов";
            } else if (!this.isEmptyString(this.props.parcel.deliveryWarehouseName) && !this.isEmptyString(this.props.parcel.shipmentWarehouseName)
                && this.props.parcel.deliveryWarehouseName === this.props.parcel.shipmentWarehouseName) {
                result = result ? result : {};
                result.shipmentWarehouseName = "Точки отгрузки и доставки не должны совпадать";
            } else if (this.props.parcel.deliveryWarehouseId && this.props.parcel.shipmentWarehouseId
                && this.props.parcel.deliveryWarehouseId === this.props.parcel.shipmentWarehouseId) {
                result = result ? result : {};
                result.shipmentWarehouseName = "Точки отгрузки и доставки не должны совпадать";
            }
        }

        if (isUndefined(fieldName) || fieldName === "shipmentAddress") {
            if (this.isEmptyString(this.props.parcel.shipmentAddressName)) {
                result = result ? result : {};
                result.shipmentAddress = "Адрес отправления является обязательным полем";
            } else if (!this.props.parcel.shipmentAddress && !this.props.parcel.shipmentAddressId) {
                result = result ? result : {};
                result.shipmentAddress = "Не выбран реальный Адрес отправления";
            } else if (this.props.parcel.shipmentAddressName.length > 500) {
                result = result ? result : {};
                result.shipmentAddress = "Длина поля Адрес отправления не должна превышать 500 символов";
            }
        }

        if (fieldName === "shipmentAddressCity") {
            if (this.isEmptyString(this.props.parcel.shipmentAddressCity)) {
                result = result ? result : {};
                result.shipmentAddressCity = "Город отправления является обязательным полем";
            } else if (this.props.parcel.shipmentAddressCity.length > 200) {
                result = result ? result : {};
                result.shipmentAddressCity = "Длина поля Город отправления не должна превышать 200 символов";
            }
        }

        if (fieldName === "shipmentAddressPostalCode") {
            if (this.isEmptyString(this.props.parcel.shipmentAddressPostalCode)) {
                result = result ? result : {};
                result.shipmentAddressPostalCode = "Почтовый индекс отправления является обязательным полем";
            } else if (this.props.parcel.shipmentAddressPostalCode.length > 20) {
                result = result ? result : {};
                result.shipmentAddressPostalCode = "Длина поля Почтовый индекс отправления не должна превышать 20 символов";
            }
        }

        if (isUndefined(fieldName) || fieldName === "shipmentAddressComment") {
            if (!this.isEmptyString(this.props.parcel.shipmentAddressComment) && this.props.parcel.shipmentAddressComment.length > 1000) {
                result = result ? result : {};
                result.shipmentAddressComment = "Длина поля Комментарий к адресу отправления не должна превышать 1000 символов";
            }
        }

        if (isUndefined(fieldName) || fieldName === "deliveryWarehouseName") {
            if (!this.isEmptyString(this.props.parcel.deliveryWarehouseName) && this.props.parcel.deliveryWarehouseName.length > 200) {
                result = result ? result : {};
                result.deliveryWarehouseName = "Длина поля Точка доставки не должна превышать 200 символов";
            } else if (!this.isEmptyString(this.props.parcel.deliveryWarehouseName) && !this.isEmptyString(this.props.parcel.shipmentWarehouseName)
                && this.props.parcel.deliveryWarehouseName === this.props.parcel.shipmentWarehouseName) {
                result = result ? result : {};
                result.deliveryWarehouseName = "Точки отгрузки и доставки не должны совпадать";
            } else if (this.props.parcel.deliveryWarehouseId && this.props.parcel.shipmentWarehouseId
                && this.props.parcel.deliveryWarehouseId === this.props.parcel.shipmentWarehouseId) {
                result = result ? result : {};
                result.deliveryWarehouseName = "Точки отгрузки и доставки не должны совпадать";
            }
        }

        if (isUndefined(fieldName) || fieldName === "deliveryAddressComment") {
            if (!this.isEmptyString(this.props.parcel.deliveryAddressComment) && this.props.parcel.deliveryAddressComment.length > 1000) {
                result = result ? result : {};
                result.deliveryAddressComment = "Длина поля Комментарий к адресу доставки не должна превышать 1000 символов";
            }
        }

        if (isUndefined(fieldName) || fieldName === "deliveryAddress") {
            if (this.isEmptyString(this.props.parcel.deliveryAddressName)) {
                result = result ? result : {};
                result.deliveryAddress = "Адрес доставки является обязательным полем";
            } else if (!this.props.parcel.deliveryAddress && !this.props.parcel.deliveryAddressId) {
                result = result ? result : {};
                result.deliveryAddress = "Не выбран реальный Адрес доставки";
            } else if (this.props.parcel.deliveryAddressName.length > 500) {
                result = result ? result : {};
                result.deliveryAddress = "Длина поля Адрес доставки не должна превышать 500 символов";
            }
        }

        if (fieldName === "deliveryAddressCity") {
            if (this.isEmptyString(this.props.parcel.deliveryAddressCity)) {
                result = result ? result : {};
                result.deliveryAddressCity = "Город доставки является обязательным полем";
            } else if (this.props.parcel.deliveryAddressCity.length > 200) {
                result = result ? result : {};
                result.deliveryAddressCity = "Длина поля Город доставки не должна превышать 200 символов";
            }
        }

        if (fieldName === "deliveryAddressPostalCode") {
            if (this.isEmptyString(this.props.parcel.deliveryAddressPostalCode)) {
                result = result ? result : {};
                result.deliveryAddressPostalCode = "Почтовый индекс доставки является обязательным полем";
            } else if (this.props.parcel.deliveryAddressPostalCode.length > 20) {
                result = result ? result : {};
                result.deliveryAddressPostalCode = "Длина поля Почтовый индекс доставки не должна превышать 20 символов";
            }
        }

        if (isUndefined(fieldName) || fieldName === "senderName") {
            if (this.isEmptyString(this.props.parcel.senderName)) {
                result = result ? result : {};
                result.senderName = "Контактное лицо отправителя является обязательным полем";
            } else if (this.props.parcel.senderName.length > 255) {
                result = result ? result : {};
                result.senderName = "Длина поля Контактное лицо отправителя не должна превышать 255 символов";
            }
        }

        if (isUndefined(fieldName) || fieldName === "senderContactInfo") {
            if (this.isEmptyString(this.props.parcel.senderContactInfo) || findPhoneNumbersInText (this.props.parcel.senderContactInfo).length===0) {
                result = result ? result : {};
                result.senderContactInfo = "Телефон отправителя является обязательным полем";
            } else if (this.props.parcel.senderContactInfo.length > 25) {
                result = result ? result : {};
                result.senderContactInfo = "Длина поля Телефон отправителя не должен превышать 25 символов";
            }
        }

        if (isUndefined(fieldName) || fieldName === "recipientName") {
            if (this.isEmptyString(this.props.parcel.recipientName)) {
                result = result ? result : {};
                result.recipientName = "Контактное лицо получателя является обязательным полем";
            } else if (this.props.parcel.recipientName.length > 255) {
                result = result ? result : {};
                result.recipientName = "Длина поля Контактное лицо получателя не должна превышать 25 символов";
            }
        }

        if (isUndefined(fieldName) || fieldName === "recipientContactInfo") {
            if (this.isEmptyString(this.props.parcel.recipientContactInfo) || findPhoneNumbersInText (this.props.parcel.recipientContactInfo).length===0) {
                result = result ? result : {};
                result.recipientContactInfo = "Телефон получателя является обязательным полем";
            } else if (this.props.parcel.recipientContactInfo.length > 25) {
                result = result ? result : {};
                result.recipientContactInfo = "Длина поля Телефон получателя не должен превышать 25 символов";
            }
        }

        return result;
    }

    isEmptyString(str) {
        return str === null || str === undefined || ("" + str).length === 0;
    }

    replaceEmptyString(str) {
        if (this.isEmptyString(str)) {
            return null;
        } else {
            return str;
        }
    }

    validateCity(name, field) {
        if (name && name.length > 0) {
            let canEditShipmentAddressParts = this.props.parcel.shipmentAddress
                && this.props.parcel.shipmentAddress.countryCode
                && this.props.parcel.shipmentAddress.countryCode !== "RU"
                && this.props.parcel.canEditShipmentAddress;
            let canEditDeliveryAddressParts = this.props.parcel.deliveryAddress
                && this.props.parcel.deliveryAddress.countryCode
                && this.props.parcel.deliveryAddress.countryCode !== "RU"
                && this.props.parcel.canEditDeliveryAddress;
            if ((field == "shipmentAddressCity" && !canEditShipmentAddressParts)
                || (field == "deliveryAddressCity" && !canEditDeliveryAddressParts)) {
                return;
            }

            this.updateBusyCount(1);
            return apiPost('parcels/ref/cities/check', { companyId: this.props.parcel.companyId, searchText: name })
                .then(data => {
                    this.updateBusyCount(-1);
                    if (field == "shipmentAddressCity") {
                        this.setState({ validShipmentCity: data.result > 0 });
                    } else {
                        this.setState({ validDeliveryCity: data.result > 0 });
                    }
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                });
        }
    }

    handleInputChange(name, newValue) {
        let fieldsChanges = [
            {
                name: name,
                value: newValue
            }
        ];

        if (name === "shipmentWarehouseName") {
            fieldsChanges.push(
                {
                    name: "shipmentWarehouseId",
                    value: null
                },
                {
                    name: "canEditShipmentAddress",
                    value: true
                }
            );
        } else if (name === "deliveryWarehouseName") {
            fieldsChanges.push(
                {
                    name: "deliveryWarehouseId",
                    value: null
                },
                {
                    name: "canEditDeliveryAddress",
                    value: true
                }
            );
        } else if (name === "senderName") {
            fieldsChanges.push(
                {
                    name: "senderUserId",
                    value: null
                }
            );
        } else if (name === "recipientName") {
            fieldsChanges.push(
                {
                    name: "recipientUserId",
                    value: null
                }
            );
        } else if (name === "shipmentAddressName") {
            fieldsChanges.push(
                {
                    name: "shipmentAddress",
                    value: null
                }
            );
            fieldsChanges.push(
                {
                    name: "shipmentAddressId",
                    value: null
                }
            );
        } else if (name === "deliveryAddressName") {
            fieldsChanges.push(
                {
                    name: "deliveryAddress",
                    value: null
                }
            );
            fieldsChanges.push(
                {
                    name: "deliveryAddressId",
                    value: null
                }
            );
        } else if (name === "shipmentAddressCity") {
            this.props.parcel.shipmentAddress.city = newValue;
            fieldsChanges.push(
                {
                    name: "shipmentAddress",
                    value: this.props.parcel.shipmentAddress
                }
            );
        } else if (name === "shipmentAddressPostalCode") {
            this.props.parcel.shipmentAddress.postalCode = newValue;
            fieldsChanges.push(
                {
                    name: "shipmentAddress",
                    value: this.props.parcel.shipmentAddress
                }
            );
        } else if (name === "deliveryAddressCity") {
            this.props.parcel.deliveryAddress.city = newValue;
            fieldsChanges.push(
                {
                    name: "deliveryAddress",
                    value: this.props.parcel.deliveryAddress
                }
            );
        } else if (name === "deliveryAddressPostalCode") {
            this.props.parcel.deliveryAddress.postalCode = newValue;
            fieldsChanges.push(
                {
                    name: "deliveryAddress",
                    value: this.props.parcel.deliveryAddress
                }
            );
        }

        this.props.onFieldChange(fieldsChanges);
    }

    loadWarehouses(text) {
        return apiPost('parcels/ref/warehouses/search', { companyId: this.props.parcel.companyId, searchText: text })
            .then(data => data.entries);
    }

    loadUsers(text) {
        return apiPost('parcels/ref/users/search', { companyId: this.props.parcel.companyId, searchText: text })
            .then(data => data.entries);
    }

    loadAddressSuggestions(text, sessionKey) {
        return apiPost('parcels/addresses/suggestions', { text: text, sessionKey: sessionKey, maxCount: 10 })
            .then(data => data.entries);
    }

    loadCitySuggestions(text, sessionKey) {
        return apiPost('parcels/ref/cities/search', { companyId: this.props.parcel.companyId, searchText: text, maxCount: 10 })
            .then(data => data.entries);
    }

    handleShipmentWarehouseSelect(item) {
        this.props.onFieldChange([
            {
                name: "shipmentWarehouseId",
                value: item.id
            },
            {
                name: "shipmentWarehouseName",
                value: item.name
            },
            {
                name: "canEditShipmentAddress",
                value: item.isUserPoint
            },
            {
                name: "shipmentAddress",
                value: item.address
            },
            {
                name: "shipmentAddressId",
                value: item.address ? item.address.id : null
            },
            {
                name: "shipmentAddressName",
                value: item.address ? item.address.fullName : ''
            },
            {
                name: "shipmentPointContactInfoId",
                value: item.pointContactInfo ? item.pointContactInfo.id : ''
            },
            {
                name: "shipmentAddressComment",
                value: item.pointContactInfo ? item.pointContactInfo.comment : ''
            },
            {
                name: "senderName",
                value: item.pointContactInfo ? item.pointContactInfo.contactName : ''
            },
            {
                name: "senderContactInfo",
                value: item.pointContactInfo ? item.pointContactInfo.contactPhone : ''
            }
        ])
            .then(() => this.handleFieldEdited("shipmentWarehouseId", item.id));
    }

    handleDeliveryWarehouseSelect(item) {
        this.props.onFieldChange([
            {
                name: "deliveryWarehouseId",
                value: item.id
            },
            {
                name: "deliveryWarehouseName",
                value: item.name
            },
            {
                name: "canEditDeliveryAddress",
                value: item.isUserPoint
            },
            {
                name: "deliveryAddress",
                value: item.address
            },
            {
                name: "recipientInn",
                value: item.inn
            },
            {
                name: "recipientCompanyName",
                value: item.companyName
            },
            {
                name: "deliveryAddressId",
                value: item.address ? item.address.id : null
            },
            {
                name: "deliveryAddressName",
                value: item.address ? item.address.fullName : ''
            },
            {
                name: "deliveryPointContactInfoId",
                value: item.pointContactInfo ? item.pointContactInfo.id : ''
            },
            {
                name: "deliveryAddressComment",
                value: item.pointContactInfo ? item.pointContactInfo.comment : ''
            },
            {
                name: "recipientName",
                value: item.pointContactInfo ? item.pointContactInfo.contactName : ''
            },
            {
                name: "recipientContactInfo",
                value: item.pointContactInfo ? item.pointContactInfo.contactPhone : ''
            }
        ])
            .then(() => this.handleFieldEdited("deliveryWarehouseId", item.id));
    }

    handleShipmentAddressSelect(item) {
        this.props.onFieldChange([
            {
                name: "shipmentAddress",
                value: item
            },
            {
                name: "shipmentAddressId",
                value: null
            },
            {
                name: "shipmentAddressName",
                value: item.fullName
            }
        ])
            .then(() => {
                this.validateCity(item.city, "shipmentAddressCity");
                this.handleFieldEdited("shipmentAddress", JSON.stringify(item));
            });
    }

    handleDeliveryAddressSelect(item) {
        this.props.onFieldChange([
            {
                name: "deliveryAddress",
                value: item
            },
            {
                name: "deliveryAddressId",
                value: null
            },
            {
                name: "deliveryAddressName",
                value: item.fullName
            }
        ])
            .then(() => {
                this.validateCity(item.city, "deliveryAddressCity");
                this.handleFieldEdited("deliveryAddress", JSON.stringify(item));
            });
    }

    handleSenderSelect(item) {
        this.props.onFieldChange([
            {
                name: "senderUserId",
                value: item.id
            },
            {
                name: "senderName",
                value: item.fullName
            },
            {
                name: "senderContactInfo",
                value: item.contactInfo
            }
        ])
            .then(() => this.handleFieldEdited("senderUserId", item.id));
    }

    handleRecipientSelect(item) {
        this.props.onFieldChange([
            {
                name: "recipientUserId",
                value: item.id
            },
            {
                name: "recipientName",
                value: item.fullName
            },
            {
                name: "recipientContactInfo",
                value: item.contactInfo
            }
        ])
            .then(() => this.handleFieldEdited("recipientUserId", item.id));
    }

    handleFieldEdited(name, value) {
        if (isUndefined(value)) {
            value = this.props.parcel[name];
        }

        if (name === "shipmentAddressCity") {
            this.validateCity(value, "shipmentAddressCity");
        } else if (name === "deliveryAddressCity") {
            this.validateCity(value, "deliveryAddressCity");
        }

        if (this.props.onFieldEdited) {
            this.props.onFieldEdited(name, value);
        }
    }

    filterWarehouses(text) {
        let result = [];
        if (this.state.warehouses) {
            this.state.warehouses.forEach((entry, ind, arr) => {
                if (!text || text.length == 0 || entry.name.toLowerCase().indexOf(text.toLowerCase()) >= 0) {
                    result.push(entry);
                }
            });
        }
        return Promise.resolve(result);
    }

    renderCityError(isValid) {
        if (isValid) {
            return null;
        } else {
            let title = "Наименование города не соответствует ни одному из вариантов, поддерживаемых транспортными компаниями. Пожалуйста, укажите другое наименование города.";
            return <span className="fa fa-warning text-yellow inline-icon" title={title}></span>;
        }
    }

    renderShipmentAddressParts(isVisible, isEditable, isBusy) {
        if (isVisible) {
            return (
                <div className="box-footer box-comments">
                    <div className={"form-group form-group-sm row address-part-row" + (this.props.errors.shipmentAddressPostalCode ? " has-error" : "")}>
                        <div className="col-xs-4 col-md-3 address-part-label text-right">
                            <label htmlFor="inputShipmentAddressPostalCode">Индекс</label>
                            <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Почтовый индекс"
                                data-content="Для корректной интеграции с транспортными компаниями нужно указать правильный почтовый индекс.">
                                <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                            </a>
                        </div>
                        <div className="col-xs-8 col-md-9">
                            <TextInput id="inputShipmentAddressPostalCode"
                                title={this.props.errors.shipmentAddressPostalCode}
                                value={this.props.parcel.shipmentAddress ? this.props.parcel.shipmentAddress.postalCode : ""}
                                onChange={value => this.handleInputChange("shipmentAddressPostalCode", value)}
                                onEditComplete={() => this.handleFieldEdited("shipmentAddressPostalCode")}
                                disabled={isBusy || !isEditable}
                                maxLength={12}
                            />
                        </div>
                    </div>

                    <div className={"form-group form-group-sm row address-part-row address-part-group"}>
                        <div className="col-xs-4 col-md-3 address-part-label text-right">
                            <label htmlFor="inputShipmentAddressRegion">Регион</label>
                        </div>
                        <div className="col-xs-8 col-md-9">
                            <TextInput id="inputShipmentAddressRegion"
                                value={this.props.parcel.shipmentAddress ? this.props.parcel.shipmentAddress.region : ""}
                                disabled={isBusy || !isEditable}
                            />
                        </div>
                    </div>

                    <div className={"form-group form-group-sm row address-part-row address-part-group" + (this.props.errors.shipmentAddressCity ? " has-error" : "")}>
                        <div className="col-xs-4 col-md-3 address-part-label text-right">
                            <label htmlFor="inputShipmentAddressCity">Город</label>
                            <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Город"
                                data-content="Для корректной интеграции с транспортными компаниями город должен быть выбран из предложенных вариантов.">
                                <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                            </a>
                            {
                                //this.renderCityError(this.state.validShipmentCity)
                            }
                        </div>
                        <div className="col-xs-8 col-md-9">
                            <AutoCompleteTextInput id="inputShipmentAddressCity"
                                title={this.props.errors.shipmentAddressCity}
                                value={this.props.parcel.shipmentAddress ? this.props.parcel.shipmentAddress.city : ""}
                                getItemKey={item => item}
                                getItemValue={item => item}
                                onChange={value => this.handleInputChange("shipmentAddressCity", value)}
                                onEditComplete={() => this.handleFieldEdited("shipmentAddressCity")}
                                onItemSelect={item => this.handleInputChange("shipmentAddressCity", item)}
                                loadItems={(text, sessionKey) => this.loadCitySuggestions(text, sessionKey)}
                                disabled={isBusy || !isEditable}
                            />
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    renderDeliveryAddressParts(isVisible, isEditable, isBusy) {
        if (isVisible) {
            return (
                <div className="box-footer box-comments">
                    <div className={"form-group form-group-sm row address-part-row" + (this.props.errors.deliveryAddressPostalCode ? " has-error" : "")}>
                        <div className="col-xs-4 col-md-3 address-part-label text-right">
                            <label htmlFor="inputDeliveryAddressPostalCode">Индекс</label>
                            <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Почтовый индекс"
                                data-content="Для корректной интеграции с транспортными компаниями нужно указать правильный почтовый индекс.">
                                <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                            </a>
                        </div>
                        <div className="col-xs-8 col-md-9">
                            <TextInput id="inputDeliveryAddressPostalCode"
                                title={this.props.errors.deliveryAddressPostalCode}
                                value={this.props.parcel.deliveryAddress ? this.props.parcel.deliveryAddress.postalCode : ""}
                                onChange={value => this.handleInputChange("deliveryAddressPostalCode", value)}
                                onEditComplete={() => this.handleFieldEdited("deliveryAddressPostalCode")}
                                disabled={isBusy || !isEditable}
                                maxLength={12}
                            />
                        </div>
                    </div>

                    <div className={"form-group form-group-sm row address-part-row address-part-group"}>
                        <div className="col-xs-4 col-md-3 address-part-label text-right">
                            <label htmlFor="inputDeliveryAddressRegion">Регион</label>
                        </div>
                        <div className="col-xs-8 col-md-9">
                            <TextInput id="inputDeliveryAddressRegion"
                                value={this.props.parcel.deliveryAddress ? this.props.parcel.deliveryAddress.region : ""}
                                disabled={isBusy || !isEditable}
                            />
                        </div>
                    </div>

                    <div className={"form-group form-group-sm row address-part-row address-part-group" + (this.props.errors.deliveryAddressCity ? " has-error" : "")}>
                        <div className="col-xs-4 col-md-3 address-part-label text-right">
                            <label htmlFor="inputDeliveryAddressCity">Город</label>
                            <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Город"
                                data-content="Для корректной интеграции с транспортными компаниями город должен быть выбран из предложенных вариантов.">
                                <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                            </a>
                            {
                                //this.renderCityError(this.state.validDeliveryCity)
                            }
                        </div>
                        <div className="col-xs-8 col-md-9">
                            <AutoCompleteTextInput id="inputDeliveryAddressCity"
                                title={this.props.errors.deliveryAddressCity}
                                value={this.props.parcel.deliveryAddress ? this.props.parcel.deliveryAddress.city : ""}
                                getItemKey={item => item}
                                getItemValue={item => item}
                                onChange={value => this.handleInputChange("deliveryAddressCity", value)}
                                onEditComplete={() => this.handleFieldEdited("deliveryAddressCity")}
                                onItemSelect={item => this.handleInputChange("deliveryAddressCity", item)}
                                loadItems={(text, sessionKey) => this.loadCitySuggestions(text, sessionKey)}
                                disabled={isBusy || !isEditable}
                            />
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    render() {
        let isCoordinator = getRoles().indexOf('Coordinator') >= 0;
        let isAuthor = getRoles().indexOf('Author') >= 0;
        let isAuthorEditable = this.props.isNew || isAuthor || isCoordinator;
        let isOnMailRoom = this.props.parcel.statusCode === "SentToMailRoom";
        let isCreatedEditable = (isAuthor || isCoordinator) && this.props.parcel.statusCode == 'Created' && !this.props.isNew;
        let isOnlyBeforeSendEditable = this.props.isNew
            || this.props.parcel.statusCode === "Created"
            || (this.props.parcel.statusCode === "SentToMailRoom" && isCoordinator);
        let canEditShipmentAddressParts = this.props.parcel.shipmentAddress
            && ((this.props.parcel.shipmentAddress.countryCode
                && this.props.parcel.shipmentAddress.countryCode !== "RU"
                && this.props.parcel.canEditShipmentAddress) || isCreatedEditable);
        let canEditDeliveryAddressParts = this.props.parcel.deliveryAddress
            && ((this.props.parcel.deliveryAddress.countryCode
                && this.props.parcel.deliveryAddress.countryCode !== "RU"
                && this.props.parcel.canEditDeliveryAddress) || isCreatedEditable);

        let isBusy = this.props.isBusy || this.state.busyCount > 0;
        let canEditShipmentAddress = isCreatedEditable || (this.props.parcel.canEditShipmentAddress && isOnlyBeforeSendEditable && isAuthorEditable);
        let canEditDeliveryAddress = isCreatedEditable || (this.props.parcel.canEditDeliveryAddress && isOnlyBeforeSendEditable && isAuthorEditable);
        return (
            <div>
                <div className="row">
                    <div className="col-sm-6">
                        <div>
                            <h4 className="text-center">Данные отправления</h4>
                        </div>

                        <div className={"form-group" + (this.props.errors.shipmentWarehouseId || this.props.errors.shipmentWarehouseName ? " has-error" : "")}>
                            <label htmlFor="inputShipmentWarehouse">Точка отправления</label>
                            <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Точка отправления"
                                data-content="Название места/организации, откуда необходимо забрать посылку. Точка отправления будет сохранена в истории ваших отправок.">
                                <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                            </a>
                            <AutoCompleteTextInput id="inputShipmentWarehouse"
                                title={this.props.errors.shipmentWarehouseId ? this.props.errors.shipmentWarehouseId : this.props.errors.shipmentWarehouseName}
                                value={this.props.parcel.shipmentWarehouseName}
                                getItemKey={item => item.id}
                                getItemValue={item => item.name}
                                onChange={value => this.handleInputChange("shipmentWarehouseName", value)}
                                onEditComplete={() => this.handleFieldEdited("shipmentWarehouseName")}
                                onItemSelect={item => this.handleShipmentWarehouseSelect(item)}
                                items={this.state.warehouses}
                                shouldItemRender={(item, value) => (!value || value.length == 0 || (item.name && item.name.toLowerCase().indexOf(value.toLowerCase()) >= 0))}
                                renderItemValue={item => item.isUserPoint ? item.name : <b>{item.name}</b>}
                                disabled={isBusy || !isOnlyBeforeSendEditable || !isAuthorEditable}
                                isItemSelected={this.props.parcel.shipmentWarehouseId !== null}
                                maxLength={35}
                            />
                            <small className="control-footer-hint">Максимум 35 символов</small>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div>
                            <h4 className="text-center">Данные доставки</h4>
                        </div>

                        <div className={"form-group" + (this.props.errors.deliveryWarehouseId || this.props.errors.deliveryWarehouseName ? " has-error" : "")}>
                            <label htmlFor="inputDeliveryWarehouseName">Точка доставки</label>
                            <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Точка доставки"
                                data-content="Название места/организации, куда необходимо доставить посылку. Точка доставки будет сохранена в истории ваших отправок.">
                                <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                            </a>
                            <AutoCompleteTextInput id="inputDeliveryWarehouseName"
                                title={this.props.errors.deliveryWarehouseId ? this.props.errors.deliveryWarehouseId : this.props.errors.deliveryWarehouseName}
                                value={this.props.parcel.deliveryWarehouseName}
                                getItemKey={item => item.id}
                                getItemValue={item => item.name}
                                onChange={value => this.handleInputChange("deliveryWarehouseName", value)}
                                onEditComplete={() => this.handleFieldEdited("deliveryWarehouseName")}
                                onItemSelect={item => this.handleDeliveryWarehouseSelect(item)}
                                items={this.state.warehouses}
                                shouldItemRender={(item, value) => (!value || value.length == 0 || (item.name && item.name.toLowerCase().indexOf(value.toLowerCase()) >= 0))}
                                renderItemValue={item => item.isUserPoint ? item.name : <b>{item.name}</b>}
                                disabled={isBusy || !isOnlyBeforeSendEditable || !isAuthorEditable}
                                isItemSelected={this.props.parcel.deliveryWarehouseId !== null}
                                maxLength={35}
                            />
                            <small className="control-footer-hint">Максимум 35 символов</small>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-6">
                        <div className={"form-group" + (this.props.errors.shipmentAddress ? " has-error" : "")}>
                            <label htmlFor="inputShipmentAddress">Адрес отправления<span className="text-red">*</span></label>
                            <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Адрес отправления" data-html="true"
                                data-content="Адрес места забора груза. Необходимо выбрать существующий адрес из выпадающего списка. Для указания дополнительных сведений воспользуйтесь полем «Комментарий к адресу отправки». <b>Адреса за рубежом необходимо вводить латиницей, начиная со страны.</b>">
                                <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                            </a>
                            <AutoCompleteTextInput id="inputShipmentAddress"
                                title={this.props.errors.shipmentAddress}
                                value={this.props.parcel.shipmentAddressName}
                                getItemKey={item => item.fias}
                                getItemValue={item => item.fullName}
                                onChange={value => this.handleInputChange("shipmentAddressName", value)}
                                onItemSelect={item => this.handleShipmentAddressSelect(item)}
                                loadItems={(text, sessionKey) => this.loadAddressSuggestions(text, sessionKey)}
                                disabled={isBusy || !canEditShipmentAddress}
                                isItemSelected={this.props.parcel.shipmentAddress !== null}
                                multi
                            />

                            {this.renderShipmentAddressParts(true, canEditShipmentAddressParts, isBusy)}

                            <small className="control-footer-hint">Введите как минимум 3 символа для появления подсказок</small>
                        </div>

                        <div className={"form-group" + (this.props.errors.shipmentAddressComment ? " has-error" : "")}>
                            <label htmlFor="inputShipmentAddressComment">Комментарий к адресу отправления</label>
                            <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Комментарий к адресу отправления"
                                data-content="Дополнительные сведения к адресу отправления (этаж, кабинет, проходная и т.п.)">
                                <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                            </a>
                            <TextInput id="inputShipmentAddressComment"
                                title={this.props.errors.shipmentAddressComment}
                                value={this.props.parcel.shipmentAddressComment}
                                onChange={value => this.handleInputChange("shipmentAddressComment", value)}
                                onEditComplete={() => this.handleFieldEdited("shipmentAddressComment")}
                                disabled={isBusy || !isAuthorEditable}
                            />
                        </div>

                        <div className={"form-group" + (this.props.errors.senderName ? " has-error" : "")}>
                            <label htmlFor="inputSenderName">Контактное лицо отправителя<span className="text-red">*</span></label>
                            <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Контактное лицо отправителя" data-content="ФИО отправителя">
                                <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                            </a>
                            <AutoCompleteTextInput id="inputSenderName"
                                title={this.props.errors.senderName}
                                value={this.props.parcel.senderName}
                                getItemKey={item => item.id}
                                getItemValue={item => item.fullName}
                                onChange={value => this.handleInputChange("senderName", value)}
                                onEditComplete={() => this.handleFieldEdited("senderName")}
                                onItemSelect={item => this.handleSenderSelect(item)}
                                loadItems={text => this.loadUsers(text)}
                                disabled={isBusy || !isOnlyBeforeSendEditable || !isAuthorEditable}
                                maxLength={35}
                            />
                            <small className="control-footer-hint">Введите как минимум 3 символа для поиска по справочнику пользователей. Максимум 35 символов.</small>
                        </div>

                        <div className={"form-group" + (this.props.errors.senderContactInfo ? " has-error" : "")}>
                            <label htmlFor="inputSenderContactInfo">Телефон отправителя<span className="text-red">*</span></label>
                            <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Телефон отправителя" data-content="Для отправки груза введите номер мобильного телефона в формате +7xxxxxxxxxx.">
		                        <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
	                        </a>
                            <TextInput id="inputSenderContactInfo"
                                title={this.props.errors.senderContactInfo}
                                value={this.props.parcel.senderContactInfo}
                                onChange={value => this.handleInputChange("senderContactInfo", value)}
                                onEditComplete={() => this.handleFieldEdited("senderContactInfo")}
                                disabled={isBusy || !isOnlyBeforeSendEditable || !isAuthorEditable}
                                maxLength={25}
                            />
                            <small className="control-footer-hint">Максимум 25 символов.Формат ввода +7xxxxxxxxxx.</small>
                        </div>
                    </div>

                    <div className="col-sm-6">
                        <div className={"form-group" + (this.props.errors.deliveryAddress ? " has-error" : "")}>
                            <label htmlFor="inputDeliveryAddress">Адрес доставки<span className="text-red">*</span></label>
                            <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Адрес доставки" data-html="true"
                                data-content="Адрес места доставки груза. Необходимо выбрать существующий адрес из выпадающего списка. Для указания дополнительных сведений воспользуйтесь полем «Комментарий к адресу доставки». <b>Адреса за рубежом необходимо вводить латиницей, начиная со страны.</b>">
                                <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                            </a>
                            <AutoCompleteTextInput id="inputDeliveryAddress"
                                title={this.props.errors.deliveryAddress}
                                value={this.props.parcel.deliveryAddressName}
                                getItemKey={item => item.fias}
                                getItemValue={item => item.fullName}
                                onChange={value => this.handleInputChange("deliveryAddressName", value)}
                                onItemSelect={item => this.handleDeliveryAddressSelect(item)}
                                loadItems={(text, sessionKey) => this.loadAddressSuggestions(text, sessionKey)}
                                disabled={isBusy || !canEditDeliveryAddress}
                                isItemSelected={this.props.parcel.deliveryAddress !== null}
                                multi
                            />

                            {this.renderDeliveryAddressParts(true, canEditDeliveryAddressParts, isBusy)}

                            <small className="control-footer-hint">Введите как минимум 3 символа для появления подсказок</small>
                        </div>

                        <div className={"form-group" + (this.props.errors.deliveryAddressComment ? " has-error" : "")}>
                            <label htmlFor="inputDeliveryAddressComment">Комментарий к адресу доставки</label>
                            <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Комментарий к адресу доставки"
                                data-content="Дополнительные сведения к адресу доставки (этаж, кабинет, проходная и т.п.)">
                                <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                            </a>
                            <TextInput id="inputDeliveryAddressComment"
                                title={this.props.errors.deliveryAddressComment}
                                value={this.props.parcel.deliveryAddressComment}
                                onChange={value => this.handleInputChange("deliveryAddressComment", value)}
                                onEditComplete={() => this.handleFieldEdited("deliveryAddressComment")}
                                disabled={isBusy || !isAuthorEditable}
                            />
                        </div>

                        <div className={"form-group" + (this.props.errors.recipientName ? " has-error" : "")}>
                            <label htmlFor="inputRecipientName">Контактное лицо получателя<span className="text-red">*</span></label>
                            <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Контактное лицо получателя" data-content="ФИО получателя">
                                <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                            </a>
                            <AutoCompleteTextInput id="inputRecipientName"
                                title={this.props.errors.recipientName}
                                value={this.props.parcel.recipientName}
                                getItemKey={item => item.id}
                                getItemValue={item => item.fullName}
                                onChange={value => this.handleInputChange("recipientName", value)}
                                onEditComplete={() => this.handleFieldEdited("recipientName")}
                                onItemSelect={item => this.handleRecipientSelect(item)}
                                loadItems={text => this.loadUsers(text)}
                                disabled={isBusy || !isOnlyBeforeSendEditable || !isAuthorEditable}
                                maxLength={35}
                            />
                            <small className="control-footer-hint">Введите как минимум 3 символа для поиска по справочнику пользователей. Максимум 35 символов.</small>
                        </div>

                        <div className={"form-group" + (this.props.errors.recipientContactInfo ? " has-error" : "")}>
                            <label htmlFor="inputRecipientContactInfo">Телефон получателя<span className="text-red">*</span></label>
                            <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Телефон получателя" data-content="Для отправки груза введите номер мобильного телефона в формате +7xxxxxxxxxx.">
	                            <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                            </a>
                            <TextInput id="inputRecipientContactInfo"
                                title={this.props.errors.recipientContactInfo}
                                value={this.props.parcel.recipientContactInfo}
                                onChange={value => this.handleInputChange("recipientContactInfo", value)}
                                onEditComplete={() => this.handleFieldEdited("recipientContactInfo")}
                                disabled={isBusy || !isOnlyBeforeSendEditable || !isAuthorEditable}
                                maxLength={25}
                            />
                            <small className="control-footer-hint">Максимум 25 символов.Формат ввода +7xxxxxxxxxx.</small>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/parcels/form/tabs/addressTab.jsx